import { useCheckAuthAndRedirectProps } from "./fetch";
import { CheckAuthAndRedirectUi } from "./ui";

export const CheckAuthAndRedirect: React.FC<{
  pathNotFound?: boolean;
  children?: React.ReactNode;
}> = ({ pathNotFound, children }) => {
  const props = useCheckAuthAndRedirectProps({ pathNotFound });
  return <CheckAuthAndRedirectUi {...props}>{children}</CheckAuthAndRedirectUi>;
};
